export const debunkList = [
  {
    id: "db-2026-0828-attitude",
    title: "“导演片场摔东西骂人”传闻",
    rumor: "匿名账号称某导演在片场对工作人员发脾气并摔砸道具，配文使用夸张描述。",
    result: "不实。三名不同岗位的在场从业者公开说明当天拍摄正常，官方花絮完整发布且未见相关情形，原帖已删除。",
    officialSource: "现场花絮 + 多名在场从业者公开说明",
    date: "2026-08-28",
    category: "口碑争议",
  },
  {
    id: "db-2026-0821-relay",
    title: "“某综艺录制现场发生肢体冲突”传闻",
    rumor: "社交平台流传一段演出场馆外的模糊视频，被指为综艺录制现场的冲突画面。",
    result: "误读。该视频实为另一场商业活动的收工场景，场馆官方公开了当天活动安排予以说明，画面中人员为道具搬运。",
    officialSource: "场馆方公开活动安排说明",
    date: "2026-08-21",
    category: "口碑争议",
  },
  {
    id: "db-2026-0815-health",
    title: "“某艺人因健康问题全面停工”传闻",
    rumor: "多个账号称该艺人因健康原因暂停所有工作，并称已有工作室内部通知。",
    result: "不实。工作室公开了近期行程安排，艺人按计划参加公开活动，网传“内部通知”无法提供来源。",
    officialSource: "工作室行程公告",
    date: "2026-08-15",
    category: "事业动向",
  },
  {
    id: "db-2026-0809-endorse",
    title: "“某品牌与艺人合作提前终止”传闻",
    rumor: "有帖子称品牌已下架全部相关物料，暗示合作终止。",
    result: "误读。物料调整属于品牌统一更换视觉素材，品牌方面确认合作正常进行，新一季物料已完成拍摄。",
    officialSource: "品牌方公开回应",
    date: "2026-08-09",
    category: "事业动向",
  },
  {
    id: "db-2026-0802-plagiarism",
    title: "“某短剧海报抄袭知名电影”传闻",
    rumor: "网友对比指出短剧海报构图与某电影高度相似。",
    result: "不实。两张海报均由同一家设计工作室完成，短剧方早于电影方签约定稿，双方均有时间戳记录，属同源设计引发误判。",
    officialSource: "设计工作室时间线说明",
    date: "2026-08-02",
    category: "口碑争议",
  },
  {
    id: "db-2026-0726-charity",
    title: "“某艺人捐款未到账”传闻",
    rumor: "有帖子质疑某艺人公开承诺的公益款项未实际到账。",
    result: "不实。受赠机构公开说明了到账时间与项目进度，款项分两批拨付，均在承诺周期内完成。",
    officialSource: "受赠机构项目进展说明",
    date: "2026-07-26",
    category: "口碑争议",
  },
];